import React from 'react';
import { FaServer, FaUsers, FaLaptop, FaCode, FaMobileAlt, FaCubes, FaDatabase, FaShieldAlt } from 'react-icons/fa';

const skills = [
    { icon: FaCode,       label: 'React & JavaScript',         sub: 'Development' },
    { icon: FaMobileAlt,  label: 'iOS & Android Apps',          sub: 'Development' },
    { icon: FaCubes,      label: 'Blockchain / Web3',           sub: 'Development' },
    { icon: FaDatabase,   label: 'MongoDB, Firebase, CosmosDB', sub: 'Development' },
    { icon: FaServer,     label: 'Server Management',           sub: 'IT' },
    { icon: FaUsers,      label: 'User & Access Control',       sub: 'IT' },
    { icon: FaLaptop,     label: 'Device Management',           sub: 'IT' },
    { icon: FaShieldAlt,  label: 'Security-First Mindset',      sub: 'IT' },
];

const BodyTest = () => {
    return (
        <section id="about" className="section-divider py-24" style={{ background: 'rgba(7,8,15,0.82)' }}>
            <div className="container max-w-5xl mx-auto px-6 lg:px-8">

                <div className="mb-16">
                    <span className="text-orange-400 text-xs tracking-widest uppercase font-medium">About</span>
                    <h2 className="text-4xl font-bold text-white mt-3 mb-5">Hi, I'm Chandler.</h2>
                    <p className="text-lg max-w-2xl leading-relaxed" style={{ color: 'rgba(255,255,255,0.52)' }}>
                        I'm a developer and IT professional with 5+ years building for the web, mobile,
                        blockchain, and 3+ years keeping infrastructure secure and running. I care about
                        clean code, solid UX, and systems that don't break.
                    </p>
                </div>

                <div>
                    <span className="text-orange-400 text-xs tracking-widest uppercase font-medium">Skills &amp; Experience</span>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
                        {skills.map(({ icon: Icon, label, sub }) => (
                            <div key={label} className="glass-card flex items-start gap-4 p-5">
                                <div
                                    className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl"
                                    style={{
                                        background: 'rgba(249,115,22,0.14)',
                                        border: '1px solid rgba(249,115,22,0.28)',
                                        color: 'rgba(255,185,110,0.9)',
                                    }}
                                >
                                    <Icon size={16} />
                                </div>
                                <div>
                                    <p className="font-medium text-sm leading-snug" style={{ color: 'rgba(255,255,255,0.88)' }}>
                                        {label}
                                    </p>
                                    <p className="text-xs mt-1 tracking-wide" style={{ color: 'rgba(255,255,255,0.36)' }}>
                                        {sub}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default BodyTest;
